<template>
    <div class="not-found-page">
        <div class="not-found-page__text-content">
            <h1 class="not-found-page__title">401</h1>
            <h1 class="not-found-page__title upper-case">{{ $t('authorisation required') }}</h1>
            <div class="notice">
                {{ $capitalize($t('this page is not publicly avaliable').toString()) }}.<br>
                {{ $capitalize($t('to access it please login first').toString()) }}.
            </div>
        </div>
        <Illustration image="/static/img/illustrations/page__unathorized.svg" />
    </div>
</template>

<script>
    import {
        mapGetters,
        mapActions,
    } from 'vuex';

    import { RouteName } from '@app/router/constants/RouteName';
    import modalCodes from '@store/modules/ui/shared/modal/modalCodes';

    export default {
        name: 'PageNotAuthorized',
        created() {
            if (this.isLoggedIn) {
                this.$router.push({ name: RouteName.App.Home });
            } else if (this.loginGuardedRoute) {
                this.setModal(modalCodes.login);
            }
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
            ...mapGetters('navigation', [
                'loginGuardedRoute',
            ]),
            isLoggedIn() {
                return !!this.user;
            },
        },
        watch: {
            // This part of code is only relevant to non-Belgium targets.
            // Belgium will never reach this code because of the multi-domain behaviour
            isLoggedIn(value) {
                if (value) {
                    const route = this.loginGuardedRoute?.name
                        ? { name: this.loginGuardedRoute.name }
                        : { name: RouteName.App.Home };
                    this.$router.push(route);
                }
            },
        },
        methods: {
            ...mapActions('navigation', ['clearLoginGuardedRoute']),
            ...mapActions('ui/modal', ['setModal']),
        },
        beforeDestroy() {
            this.clearLoginGuardedRoute();
        },
    };
</script>
